import exchangesRatePairsCount from '../widgets/exchangesRatePairsCount.js';

(function ($) {
    $(async function () {
        window.$ = jQuery;
        await exchangesRatePairsCount.updateDynamicsData();
    });
}(jQuery));